import { SvelteFacet } from "./SvelteFacet";
import { addFilterButtonTeaser } from "./FilterButton";
import { events } from "../events";
import { SvelteFacetValue } from "./SvelteFacetValue";

export function registerBlackFridayHandlers() {
  events.onFilterSectionLoaded(blackFridayFlagTeaser);
}

function blackFridayFlagTeaser() {
  const actionFacet: SvelteFacet | undefined = SvelteFacet.facetName("aktion");
  const blackFridayFacetValue: SvelteFacetValue = actionFacet?.values.find(
    (value) => value.facetValue.value === "black-friday",
  );
  const blackFridayFacet: SvelteFacet | undefined = SvelteFacet.facetName("black-friday");

  if (
    (actionFacet && blackFridayFacetValue && !actionFacet.facet.hidden) ||
    (blackFridayFacet && !blackFridayFacet.facet.hidden)
  ) {
    addFilterButtonTeaser("black-friday");
  }
}
